import { companyName } from "../../config";

export const imageTypeOneBannerData = {
  imageSection: {
    folderName: "services/Mobile",
    imageName: "react.png",
    imageText2: "React Native App Development Service",
    buttonDetails: {
      buttonType: "button",
      buttonLink: "request-quote",
      buttonText: "Let's connect",
    },
  },
};

export const typeThreeBannerData = {
  heading: "Advantages of React Native App Development",
  description:
    "React Native is an open-source mobile application development framework and makes use of the same design concept as React.js, composing a rich mobile UI from available components. Allowing to build the mobile apps with JavaScript, they hardly differ from the normal applications built in Java, Objective-C or Swift. Combining the advantages of native and hybrid apps, RN speeds up the development process, giving native-like user-experience. The apps thus built are faster, highly-performant and cost-effective.",
  details: [
    {
      iconName: `${companyName}-RN-SCB`,
      label: "Single Codebase and Reusable Code",
      content:
        "The same code can be used across web and mobile platforms, eliminating the need to build separate apps individually.",
    },
    {
      label: "Pre-Built Components",
      iconName: `${companyName}-RN-PBC`,
      content:
        "RN has a library of pre-built components that can be used to speed up the development process.",
    },
    {
      label: "Simple UI",
      iconName: `${companyName}-RN-RU`,
      content:
        "User-interface is responsive with quick load times to provide a smooth experience.",
    },
    {
      label: "Documentation",
      iconName: `${companyName}-RN-D`,
      content:
        "All the documentation is open for everyone and is available for free to everyone in Reach Native Community. People get recognized for writing code. Developers can share their experiences and create portfolios encouraging their peers to improve their code.",
    },
    {
      label: "Modular Architecture",
      iconName: `${companyName}-RN-MA`,
      content:
        "React Native allows development teams to flexibly update or upgrade applications easily. Additionally, the reuse of the modules that work across the mobile and web APIs speeds up the development process.",
    },
    {
      label: "Declarative Coding Style",
      iconName: `${companyName}-RN-DC`,
      content:
        "React Native goes well with declarative programming rather than an imperative approach. This simplifies coding paradigms and the subsequent coding process making it easy for both the system and developers.",
    },
    {
      label: "Third-Party Plugin Support",
      iconName: `${companyName}-RN-TPPS`,
      content:
        "React Native comes with two types of plugins: native modules and JavaScript modules. Additionally, some of the most prominent plugins to be used with React Native are: React Native Selectme, React Native Router Flux, React Native Vector Icons, React Native Gifted Spinner, React Native Drawer and React Native Modalbox.",
    },
    {
      label: "Comes with ready-made solutions and libraries",
      iconName: `${companyName}-RN-CWRMSAL`,
      content:
        "Some tools and libraries act as fillers and supplement the code with proper type checking – the famous ones are PropTypes and Flow, ESLint is a perfect tool for linting, Axios, react-native-firebase, and Apollo Client are used for setting up the networking workflow in React Native projects.",
    },
    {
      label: "Modular Architecture",
      iconName: `${companyName}-RN-MA`,
      content:
        "Modular architecture/programming provides flexibility within the development team that makes it extremely easy to generate updates. It's also possible to reuse modules that work both with the web and mobile APIs.",
    },
    {
      label: "Live & Hot Reloading",
      iconName: `${companyName}-RN-HR`,
      content:
        "Developers may see the live changes in their application while development.",
    },
    {
      label: "Shorter Learning Curve",
      iconName: `${companyName}-RN-SLC`,
      content: "RN is readable and easily learnable..",
    },
  ],
};

export const topTypeThreeBannerData = {
  heading: "React Native App Development Company",
  para:
    "React Native takes the idea of JavaScript library modeled on flux patterns to render a highly performant user interface a step further. Get all your cross-platform app development requirements fulfilled here. We provide all types of React Native App Development Services for almost all industry domains across the globe. Hire React Native Developers from our experienced team of developers for your next mobile app project. Our React Native App Developers are available at a fixed price, hourly and monthly. Companies that claim to create 100% React Native apps isn’t the case. React Native just makes up for a small component and is implemented in a scattered approach. See, why our Developers prefer React Native:",
  details: [
    {
      label: "RN apps",
      iconName: `${companyName}-RN-RNA`,
      content: "can run across operating systems (Android/iOS).",
    },
    {
      label: "Requires ",
      iconName: `${companyName}-RN-RT`,
      content: "minimal time to develop applications.",
    },
    {
      label: "React Native",
      iconName: `${companyName}-RN-RU`,
      content: "has rich UI Components.",
    },
    {
      label: "Netflix, Instagram,",
      iconName: `${companyName}-RN-RNA`,
      content: "Facebook, Bloomberg, Skype, and Walmart rely on React Native..",
    },
    {
      label: "Applications ",
      iconName: `${companyName}-RN-A`,
      content:
        "developed with react-native are of the same speed as a native application.",
    },
    {
      label: "With ",
      iconName: `${companyName}-RN-HR`,
      content:
        "Hot Reloading you can run new code while retaining your application state..",
    },
  ],
  showButton: true,
  buttonType: "button",
  buttonText: "Hire React Native Developer",
  buttonLink: "/request-quote",
};

export const appInfographics = {
  heading: "Our React Native App Development Services",
  description:
    "KDR is a leading React Native App Development Company having expertise in building RN Applications compatible across platforms. To ensure that our React Native solutions cater to diverse needs across industries and domains, we offer a full stack of advanced mobile application development services, making use of our Hybrid App Development, migrating jquery/NativeScript, Development of plugins, Server-side API for Mobile and maintenance solutions and experts who have adequate knowledge of React Native Modules and Frameworks. Hire React Native Developers from kdr to get best-in-class applications that work seamlessly across platforms turning every imaginable idea into reality and gain the functional edge driven by in-depth research and knowledgeable insights. We have created React Native Android app/React Native iOS App/React Native UI/UX App for different verticals like m-commerce, healthcare, travel, etc. Our specific React Native Development Services include:",
  infoContent: [
    {
      heading: "Mobile Application Development",
      description:
        "We follow a high-quality Development Process to create contemporary & aesthetic UI/UX designs and user-friendly applications. All components, functions, API libraries are deeply researched for swift development.",
      imageFolder: "react-native",
      imageName: "mobile-app-development.svg",
    },
    {
      heading: "Mobile App Consulting",
      description:
        "We follow a systematic approach to building applications by optimizing our efforts, utilizing the available resources and time in the best possible way. We begin by understanding the client's requirements, create a roadmap, do in-depth business analysis and apply our creativity in developing beautiful applications.",
      imageFolder: "react-native",
      imageName: "consulting.svg",
    },
    {
      heading: "Mobile App Migration",
      description:
        "We assist clients by migrating legacy applications onto other platforms or current programming languages in demand – React Native Platform.",
      imageFolder: "react-native",
      imageName: "app-migration.svg",
    },
    {
      heading: "React Native Customization Services",
      description:
        "kdr can add experienced React Native Programmers to your existing team or build a React Native Application from scratch. We build a custom development plan based on resource availability, client's demand, budget and time constraints. kdr creates state-of-the-art React Native applications to scale up your business. Contact our team and get access to top React Native development talent today.",
      imageFolder: "react-native",
      imageName: "customization-service.svg",
    },
    {
      heading: "React Native Support and Maintenance",
      description:
        "kdr offers reliable React Native Support and Maintenance Services. We follow complete SDLC thus extending our mobile app development services beyond development. The developed applications are flawless without specific issues throughout the life span. ReactJS is regarded as an advanced technology framework that usually requires technical expertise and skills whether it is about the creation of the custom applications with it.",
      imageFolder: "react-native",
      imageName: "service-maintenance.svg",
    },
  ],
};
export const serviceOfferedTypeTwo = {
  heading: "Why choose kdr for React Native App Development Services?",
  description:
    "Hire React Native developers with vast experience from kdr who are passionate about their React Native Applications. Our React native developers provide the best possible solutions to satisfy the most urgent needs of the businesses in marketing their products and services in no time. Here are some key reasons to hire our React Native developers for building state-of-art successful mobile applications:",
  data: [
    "100% Client Satisfaction",
    "Expertise In React Native Development",
    "On-Time Project Delivery",
    "Quality Services",
    "Immediate Support and Maintenance",
    "Hire Dedicated Developers (Hourly, Fixed Price)",
  ],
};
